// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    /* Primitive tokens */
    /* Border radius */
    --gw-border-radius-0: 0;
    --gw-border-radius-050: 2px;
    --gw-border-radius-100: 4px;
    --gw-border-radius-150: 6px;
    --gw-border-radius-200: 8px;
    --gw-border-radius-250: 10px;
    --gw-border-radius-300: 12px;
    --gw-border-radius-400: 16px;
    --gw-border-radius-450: 18px;
    --gw-border-radius-500: 20px;
    --gw-border-radius-600: 24px;
    --gw-border-radius-750: 30px;
    --gw-border-radius-full: 9999px;

    /* Border width */
    --gw-border-width-input: 0.5px;
    --gw-border-width-025: 1px;
    --gw-border-width-050: 2px;
    --gw-border-width-100: 4px;

    /* Semantic polaris tokens*/
    --gw-p-border-radius-button: var(--gw-border-radius-200);
    --gw-p-border-radius-card: var(--gw-border-radius-300);
    --gw-p-border-radius-popover: var(--gw-border-radius-300);
    --gw-p-border-radius-progress-bar: var(--gw-border-radius-750);
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/borders.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;;IAE/B,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;;IAE1B,2BAA2B;IAC3B,wDAAwD;IACxD,sDAAsD;IACtD,yDAAyD;IACzD,8DAA8D;AAClE","sourcesContent":[":root,\n:host {\n    /* Primitive tokens */\n    /* Border radius */\n    --gw-border-radius-0: 0;\n    --gw-border-radius-050: 2px;\n    --gw-border-radius-100: 4px;\n    --gw-border-radius-150: 6px;\n    --gw-border-radius-200: 8px;\n    --gw-border-radius-250: 10px;\n    --gw-border-radius-300: 12px;\n    --gw-border-radius-400: 16px;\n    --gw-border-radius-450: 18px;\n    --gw-border-radius-500: 20px;\n    --gw-border-radius-600: 24px;\n    --gw-border-radius-750: 30px;\n    --gw-border-radius-full: 9999px;\n\n    /* Border width */\n    --gw-border-width-input: 0.5px;\n    --gw-border-width-025: 1px;\n    --gw-border-width-050: 2px;\n    --gw-border-width-100: 4px;\n\n    /* Semantic polaris tokens*/\n    --gw-p-border-radius-button: var(--gw-border-radius-200);\n    --gw-p-border-radius-card: var(--gw-border-radius-300);\n    --gw-p-border-radius-popover: var(--gw-border-radius-300);\n    --gw-p-border-radius-progress-bar: var(--gw-border-radius-750);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
